'use client'

import { useCallback } from 'react'
import { toast } from 'react-toastify'

import type { CartProduct } from '../../../../_context/order-flow-context'
import type { PatientFormValues } from '../_types/patient-form.types'
import type { SubmitOrderPayload } from '@/app/[locale]/order/_services/useCreateOrder'

type UsePatientInfoSubmitParams = {
	primaryProduct: CartProduct | undefined
	isChildOrder: boolean
	isEUInsurance: boolean
	cartProducts: CartProduct[]
	createOrderMutation: { mutate: (payload: SubmitOrderPayload) => void }
}

/**
 * Validates cart presence, identifies the user for marketing (adult orders), and submits the order.
 */
export function usePatientInfoSubmit({
	primaryProduct,
	isChildOrder,
	isEUInsurance,
	cartProducts,
	createOrderMutation
}: UsePatientInfoSubmitParams) {
	return useCallback(
		async (data: PatientFormValues) => {
			if (!primaryProduct) {
				toast.error('Chyba: Košík je prázdny.', {
					position: 'top-right',
					className: '!bg-medante-pink-secondary'
				})
				return
			}

			createOrderMutation.mutate({
				...data,
				isChildOrder,
				isEUInsurance,
				cartProducts
			})
		},
		[cartProducts, createOrderMutation, isChildOrder, isEUInsurance, primaryProduct]
	)
}
